import { Clickable, Col, Icon, Line, Row, Text } from 'components';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ChatMsg } from './';

const Wrapper = styled.div`
  width: ${(props) => (props.chatVisible ? (props.isMobile ? '100%' : '450px') : '0px')};
  transition: width 0.3s;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
`;

const CustomTextArea = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  flex: 1;
`;

const Messages = styled.div`
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
`;

const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 10px 0 0;
`;

const Chat = ({
  chatVisible,
  handleChatVisible,
  currentUser,
  messages,
  sendWs,
  handleUnreadCount
}) => {
  const [body, setBody] = useState(''),
    [isFocused, setIsFocused] = useState(''),
    inputRef = useRef(null),
    { isMobile } = global;

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (!chatVisible || isMobile) return;

    setTimeout(() => {
      inputRef.current.focus();
    }, 400);
  }, [chatVisible]);

  function handleKeyDown(e) {
    if (e.keyCode !== 13 || !isFocused) return;
    if (e.keyCode === 13 && e.shiftKey) return;

    send();
  }

  function handleFocus() {
    setIsFocused(true);
    handleUnreadCount(0);
  }

  function handleBlur(e) {
    setIsFocused(false);
  }

  function scrollToBottom() {
    const el = document.getElementById('scrollContainer');

    el.scroll({
      top: el.scrollHeight,
      behavior: 'smooth'
    });
  }

  async function send() {
    if (!body.length) return;

    const payload = {
      createdAt: new Date(),
      sender: currentUser,
      body
    };

    sendWs('newMessage', payload);

    setBody('');
    inputRef.current.value = '';
    inputRef.current.focus();
  }

  return (
    <Wrapper id="conference-chat" chatVisible={chatVisible} isMobile={isMobile}>
      <Col minWid={isMobile ? '100vw' : '450px'} ht="100%">
        <Header isMobile={isMobile}>
          <Text weight="500" size="20px">
            Conference Chat
          </Text>
          {isMobile && <Icon type="close" click={handleChatVisible} />}
        </Header>

        <Line />

        <Messages>
          <ScrollContainer id="scrollContainer">
            {messages.map((msg, i) => (
              <ChatMsg data={msg} currentUser={currentUser} key={i} />
            ))}
          </ScrollContainer>
        </Messages>

        <Line />

        {!!isMobile && (
          <Clickable onClick={handleChatVisible}>
            <Row pad="5px 0">
              <Icon type="arrow_back_ios" dimensions={15} marg="0 0 0 10px" />

              <Text size="12px">Tap to return to conference</Text>
            </Row>
          </Clickable>
        )}

        <Line />

        <Row maxHt="50px" ht="50px" marg="10px 0 0 0" between pad="0 10px" start>
          <CustomTextArea
            id="conference-chat-input"
            ref={inputRef}
            value={body}
            onChange={({ target }) => setBody(target.value)}
            placeholder="Type here..."
            onBlur={handleBlur}
            onFocus={handleFocus}
          />

          <Icon
            type="send"
            click={(e) => {
              e.preventDefault();

              send();
            }}
            dimensions={25}
          />
        </Row>
      </Col>
    </Wrapper>
  );
};

export default Chat;
